import React from 'react';
import logo from '../images/logo_black.png';

export const Logo = () => (
  <img
    alt="Logo"
    src={logo}
  />
);
